import clsx from 'clsx';
import MyoshLogoDark from '../../assets/myosh-logo.svg';
import MyoshLogoLight from '../../assets/myosh-logo-white-text.svg';

export interface DynamicMyoshLogoProps {
  /** Sizing/spacing classes applied to both variants. */
  className?: string;
}

/**
 * The myosh logo that follows the colour scheme: the dark-text wordmark in light
 * mode and the white-text wordmark in dark mode (the two-colour mark can't be
 * inverted, so we swap assets). For a fixed-colour background, import the static
 * asset from `Logo` instead.
 */
export const DynamicMyoshLogo = ({ className }: DynamicMyoshLogoProps) => (
  <>
    <img src={MyoshLogoDark} alt="myosh logo" className={clsx('block dark:hidden', className)} />
    <img src={MyoshLogoLight} alt="myosh logo" className={clsx('hidden dark:block', className)} />
  </>
);
